import React from 'react';
import PropTypes from 'prop-types';
import styles from './Tab.module.scss';

const Tab = (props) => {
  const { 
    activeTab,
    label,
    onClick
  } = props

  const handleClick = () => {
    onClick(label);
  }

  let className = styles.tabListItem;

  if (activeTab === label) {
    className += ' ' + styles.tabListActive;
  }

  return (
    <li
      className={className}
      onClick={handleClick}
    >
      {label}
    </li>
  );
}

Tab.propTypes = {
  activeTab: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export { Tab };
